/**
 * User: WangMeng
 * Date: 2018-07-18
 * Time: 15:48
 * Desc: 季度营业收入波动异常
 */

import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class QuarterIncomeWave extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '季度营收波动情况';
    }

    getColumns = () => {
        return [{
            title: '',
            dataIndex: 'name',
            width: 150
        }, {
            title: '第一季度',
            dataIndex: 'firquarInco'
        }, {
            title: '第二季度',
            dataIndex: 'secquarInco'
        }, {
            title: '第三季度',
            dataIndex: 'thiquarInco'
        }, {
            title: '第四季度',
            dataIndex: 'fouquarInco'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/QuarterIncomeWave.jsx